import { render, staticRenderFns } from "./BikyConfigErrors.vue?vue&type=template&id=04be63fd&scoped=true&"
import script from "./BikyConfigErrors.vue?vue&type=script&lang=ts&"
export * from "./BikyConfigErrors.vue?vue&type=script&lang=ts&"
import style0 from "./BikyConfigErrors.vue?vue&type=style&index=0&id=04be63fd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04be63fd",
  null
  
)

export default component.exports